export default __webpack_public_path__ + "static/media/software.1cb4dc77.jpeg";